import React, { useContext, useEffect, useRef, useState } from 'react';
import SessionContext from '../../../providers/session/sessionContext';
import { makeStyles } from '@material-ui/styles';
import theme from '../../../theme';
import { Button } from '@material-ui/core';
import { useTranslation } from 'tools/i18n';
import CampaignSVG from '../../../../public/images/campaigns/pre-access-black-week-2024.svg';

const useStyles = makeStyles(() => ({
    couponCodeWrapper: {
        color: 'white',
        background: 'black',
        marginTop: 20,
        padding: 40,
        gridColumn: '1/3',
        borderRadius: 3,
        width: '100%',
    },
    couponCodeApply: {
        marginTop: 10,
        width: '100%',
        ...theme.button.purchase,
        fontSize: 13,
        backgroundColor: 'transparent',
        border: '1px solid white',
        '&:hover': {
            ...theme.button.purchaseHover,
            backgroundColor: 'white',
            color: 'black'
        },
    },
    couponText: {
        margin: '20px 0',
        // whiteSpace: 'pre-line', // flip on if using newlines from translations
        '& ul': {
            padding: 0,
            listStylePosition: 'inside'
        }
    },
}));

export default function CampaignBlock({ product, prices }) {
    const session = useContext(SessionContext);
    const actions = session.actions;
    const classes = useStyles();
    const coupons = actions.getAppliedCouponCodes();
    const { t } = useTranslation(['campaigns'])
    const [saleIsOnGoing, setSaleIsOnGoing] = useState(false);
    const couponTriggers = [
        'PREACCESS',
        'FRIENDBF',
        'SMSBF',
    ];

    useEffect(() => {
        let inviteEnd = new Date('Nov 17, 2024 00:00:00');
        let now = new Date();

        if (now < inviteEnd) {
            setSaleIsOnGoing(true);
        } else {
            setSaleIsOnGoing(session.isSaleOngoing || hasActiveCoupons(coupons));
        }
    },[product.id, coupons]);

    function hasActiveCoupons(coupons) {
        return coupons.filter((item) => couponTriggers.includes(item)).length > 0;
    }

    function triggerNewsletterPopup() {
        window.dispatchEvent(new CustomEvent('intro-popup'))
    }

    function isRegularPrice() {
        if (prices.listPrice) {
            return false;
        }

        if (product.manufacturer?.name === 'Slim Aarons') {
            return false;
        }

        if (product.productNumber.indexOf('8888-') >= 0) {
            return false;
        }

        return true;
    }

    function hasAllowedProductStreams() {
        const allowedStreamIds = '01931b126f317ed5965082b389598a6a,01931b1561be719cb5a9f0f94c40f6d3,01931babf0667a4c8da1d8e9fde47ab6';
        return product.streamIds.filter((id) => allowedStreamIds.includes(id)).length > 0;
    }

    if (!isRegularPrice() || !actions.isSalesChannelNordic() || !saleIsOnGoing || !hasAllowedProductStreams()) {
        return <></>;
    }

    if (hasActiveCoupons(coupons)) {
        return <>
            <div className={classes.couponCodeWrapper}>
                <div>
                    <CampaignSVG/>
                </div>
                <p className={classes.couponText}>
                    {t('campaign-block-text-with-access')}
                </p>
                <Button className={classes.couponCodeApply} href={'/black-week'}>
                     ALL BESTSELLERS
                </Button>
            </div>
        </>
    }

    return <>
        <div className={classes.couponCodeWrapper}>
            <div>
                <CampaignSVG/>
            </div>
            <p className={classes.couponText}>
                {t('campaign-block-text-gain-access')}
            </p>
            <Button className={classes.couponCodeApply} onClick={triggerNewsletterPopup}>
                {t('campaign-block-button')}
            </Button>
        </div>
    </>;
}
